// extracted by mini-css-extract-plugin
export default {"label":"label_label__yUAHE","required":"label_required__H9em3","errorLabel":"label_errorLabel__BZZ+q"};